import { render, staticRenderFns } from "./GroupOrderInfo.vue?vue&type=template&id=af79461e&scoped=true&"
import script from "./GroupOrderInfo.vue?vue&type=script&lang=js&"
export * from "./GroupOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrderInfo.vue?vue&type=style&index=0&id=af79461e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af79461e",
  null
  
)

export default component.exports